import { assign } from 'xstate';
import { Context } from '../companyInfo';

const assignSuccessData = assign<Context, any>((ctx, evt) => ({
    isFetching: false,
    data: evt.data?.Results[0],
}));

export default assignSuccessData;
